import { Module } from "vuex";
import { RootState } from "../types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { ConfigState } from "./types";

export const state: ConfigState = {
  userId: localStorage.user ? JSON.parse(localStorage.user).id : "",
  fecRestaurantId: null,
  societes: [],
  utilisateurs: [],
  profils: [],
  societesACreer: [],
  groupes: [],
};

const namespaced: boolean = true;

export const config: Module<ConfigState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
